import {PROTOCOL_SLIDE_TYPES} from '@learningblocks/protocol-constants/lib/Utilities';
import {updateInSlideThree} from '../../utilities';

export function slideThreeSetAsNextStep(state, payload) {
  return {
    ...state,
    protocolSection: updateDesignSection(state.protocolSection, payload),
  };
}

function updateDesignSection(protocolSection, payload) {
  function updateSlideThree(slide) {
    const {groupId, nodeId} = findNextVacant(slide.slideTree);
    if (groupId !== null && nodeId !== null) {
      slide = updateInSlideThree(slide, {
        groupId,
        nodeId,
        optionId: payload.optionID,
      });
    }
    return slide;
  }

  function updateSlide(slide) {
    if (slide.type === PROTOCOL_SLIDE_TYPES.THREE) {
      slide = updateSlideThree(slide);
    }
    return slide;
  }

  return {
    ...protocolSection,
    allSlides: protocolSection.allSlides.map(updateSlide),
  };
}

function findNextVacant(slideTree) {
  return slideTree.reduce(
    (response, group) => {
      if (response.groupId === null) {
        let node = group.groupNodes.find((node) => node.droppedId === null);
        if (node && node.nodeId >= 0) {
          response.groupId = group.groupId;
          response.nodeId = node.nodeId;
        }
      }
      return response;
    },
    {groupId: null, nodeId: null}
  );
}
